const initials = "refer";
export const UPDATE_REFER = `${initials}UPDATE_REFER`;
